import Utils from '@/common/utils/utils';
import { TextField } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { getVisibleWidth } from '../../handler/HelpDeskTicketListHandler';
import {
    onBeforeDragStartHandler,
    onBlurViewName,
    onChangeViewSelectedHelpdeskList,
    onDoubleClickViewHelpdeskList,
    onDragViewEnd,
    onEnterViewName
} from '../../handler/HelpDeskViewHandler';
import { onChangeViewName } from '@/component/ticketKnowledge/handler/ViewHandler';
import './ViewHelpDeskList.css';
import { SettingView } from './SettingView';
import Constant from '@/common/constant/Constant';
import React, { useState } from 'react';
import LockIcon from '@material-ui/icons/Lock';
import PropTypes from 'prop-types';

ViewHelpDeskList.propTypes = {
    tabs: PropTypes.object,
    viewSelected: PropTypes.any,
    setViewSelected: PropTypes.any,
    isCustomer: PropTypes.any,
    viewStructure: PropTypes.any,
    setViewStructure: PropTypes.any,
    isProjectManager: PropTypes.any,
    listView: PropTypes.any,
    setListView: PropTypes.any,
    setTriggerSearch: PropTypes.any,
    inputViewNameRef: PropTypes.any,
    userDetail: PropTypes.any
};

export default function ViewHelpDeskList(props) {
    const {
        tabs,
        viewSelected,
        setViewSelected,
        isCustomer,
        viewStructure,
        setViewStructure,
        isProjectManager,
        listView,
        setListView,
        setTriggerSearch,
        inputViewNameRef,
        userDetail
    } = props;
    const element = document.querySelector('#container');
    const nodeListView = document.querySelectorAll('.item-helpdesk');
    const [clickTimeout, setClickTimeout] = useState(null);

    let timeoutEvent;
    
    const onWheel = event => {
        element.scrollLeft +=
            event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
        event.stopPropagation();
        let containerRect = element.getBoundingClientRect();

        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let id = tabs[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: id, pos: visiblePageWidth });
        }

        // trigger wheel end
        if (timeoutEvent) clearTimeout(timeoutEvent);
        timeoutEvent = setTimeout(() => {
            for (let i = 0; i < posElem.length; i++) {
                let item = posElem[i];
                // Find first view that has entered viewport and hasn't scrolled too far
                // Threshold: view left is within SNAP_SCROLL_THRESHOLD of container width from start
                if (item.pos.left >= 0 && item.pos.left < containerRect.width * Constant.SNAP_SCROLL_THRESHOLD) {
                    // Snap to align this view at container start
                    element.scrollLeft += item.pos.left;
                    break;
                }
            }
        }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
    };

    const onTouchEnd = event => {
        let containerRect = element.getBoundingClientRect();
        if (timeoutEvent) clearTimeout(timeoutEvent);
        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let id = tabs[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: id, pos: visiblePageWidth });
        }

        // Apply same logic as onWheel (Option 3) for consistency
        for (let i = 0; i < posElem.length; i++) {
            let item = posElem[i];
            // Find first view that has entered viewport and hasn't scrolled too far
            // Threshold: view left is within SNAP_SCROLL_THRESHOLD of container width from start
            if (item.pos.left >= 0 && item.pos.left < containerRect.width * Constant.SNAP_SCROLL_THRESHOLD) {
                // Snap to align this view at container start
                element.scrollLeft += item.pos.left;
                break;
            }
        }
    };

    const onTouchCancel = event => {
        // Apply same logic as onTouchEnd for consistency
        onTouchEnd(event);
    };

    const renderTabName = view => {
        let viewNameObj = Utils.convertJSONDataToObject(view.name);
        let viewName = viewNameObj['jp'].text;

        return (
            <div
                onDoubleClick={() =>
                    onDoubleClickViewHelpdeskList(
                        view,
                        isCustomer,
                        viewStructure,
                        isProjectManager,
                        listView,
                        setListView,
                        clickTimeout,
                        setClickTimeout,
                        userDetail
                    )
                }
                style={{ width: '100%' }}
                data-view-id={view.id}
            >
                {!view.isEditName && (
                    <>
                        <div className="info-item-helpdesk">
                            <div
                                className="text-icon-container"
                                onClick={() =>
                                    onChangeViewSelectedHelpdeskList(
                                        view,
                                        viewSelected,
                                        setViewSelected,
                                        viewStructure,
                                        setViewStructure,
                                        setTriggerSearch,
                                        clickTimeout,
                                        setClickTimeout
                                    )
                                }
                            >
                                {view?.visibleType === Constant.VISIBILITY_SETTING_TYPE.PRIVATE && (
                                    <div className="lock-icon-container">
                                        <LockIcon
                                            style={{
                                                fontSize: '18px',
                                                color: '#666'
                                            }}
                                            aria-label="Private view"
                                            role="img"
                                        />
                                    </div>
                                )}
                                <p
                                    className={`tabName-tlt ${viewSelected?.id === view.id &&
                                        'title-active'}`}
                                >
                                    {viewName}
                                </p>
                            </div>
                            <SettingView view={view} {...props} />
                        </div>
                    </>
                )}
                {view.isEditName && (
                    <TextField
                        id={view.id}
                        name={view.id}
                        className={`input-view-name ${view.isError ? 'view-name-error' : ''}`}
                        defaultValue={viewName}
                        onKeyPress={e => onEnterViewName(e, view, props)}
                        onBlur={e => onBlurViewName(e, view, props)}
                        onChange={e => onChangeViewName(e, view, props)}
                        inputRef={inputViewNameRef}
                        autoFocus
                        variant="filled"
                        error={view.isError}
                    />
                )}
            </div>
        );
    };

    const renderTabListWrappedInDroppable = () => (
        <DragDropContext
            onDragEnd={e => onDragViewEnd(e, props)}
            onBeforeDragStart={e => onBeforeDragStartHandler(e, props)}
        >
            <Droppable droppableId="droppable" direction="horizontal">
                {(provided, snapshot) => (
                    <div
                        id="container"
                        onWheel={event => onWheel(event)}
                        onTouchEnd={event => onTouchEnd(event)}
                        onTouchCancel={event => onTouchCancel(event)}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {tabs.map((item, index) => (
                            <Draggable
                                key={item.id}
                                draggableId={item.id + ''}
                                index={index}
                                isDragDisabled={!item?.isMove}
                            >
                                {(provided, snapshot) => {
                                    if (snapshot.isDragging) {
                                        const slider = document.querySelector('.slider-wrapper');
                                        let parentOffsetX = 0;

                                        if (slider) {
                                            const transform = getComputedStyle(slider).transform; 
                                            if (transform && transform !== 'none') {
                                                const matrix = transform.match(/matrix.*\((.+)\)/);
                                                if (matrix) {
                                                    const values = matrix[1].split(',').map(v => parseFloat(v.trim()));
                                                    parentOffsetX = values[4] || 0;
                                                    if (parentOffsetX < 0) {
                                                        parentOffsetX = - parentOffsetX
                                                    }
                                                }
                                            }
                                        }
                                        const style = {...provided.draggableProps.style};
                                        const styleLeft = style.left + parentOffsetX - 10;
                                        const styleTop = style.top - 42;

                                        provided.draggableProps.style.left = styleLeft;
                                        provided.draggableProps.style.top = styleTop;
                                    }
                                    return (
                                        <div
                                            className={`item item-helpdesk ${viewSelected?.id ===
                                                item.id && 'active'} ${item.isError && 'view-error'} ${
                                                index === tabs.length - 1 ? 'item-helpdesk-last ' : ''
                                            }`}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            data-view-id={item.id}
                                        >
                                            {renderTabName(item)}
                                        </div>
                                    )
                                }}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );

    return <>{renderTabListWrappedInDroppable()}</>;
}
